import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import DashboardCommando from "@/pages/DashboardCommandoDual";
import Leads from "@/pages/Leads";
import Taches from "@/pages/Taches";
import ShortLinkRedirect from "@/pages/ShortLinkRedirect";
import Commissions from "@/pages/Commissions";
import FicheDossier from "@/pages/FicheDossier";
import Marketplace from "@/pages/Marketplace";
import SuiviHebdo from "@/pages/SuiviHebdo";
import DashboardCash from "@/pages/DashboardCash";
import PilotageStrategique from "@/pages/PilotageStrategique";
import DossiersSignes from "@/pages/DossiersSignes";
import DossiersPerdus from "@/pages/DossiersPerdus";
import DossiersStandby from "@/pages/DossiersStandby";
import Dossiers from "@/pages/Dossiers";
import CommandoRecommandations from "@/pages/CommandoRecommandations";
import Apporteurs from "@/pages/Apporteurs";
import Entreprises from "@/pages/Entreprises";
import RelancesRetard from "@/pages/RelancesRetard";
import Objectifs from "@/pages/Objectifs";
import ImportCSV from "@/pages/ImportCSV";
import SettingsSimulator from "@/pages/SettingsSimulator";
import AdminBrokers from "@/pages/AdminBrokers";
import AdminScoringV8 from "@/pages/AdminScoringV8";
import BosCockpit from "@/pages/BosCockpit";
import SimulationPublic from "@/pages/SimulationPublic";
import SimulationRedirect from "@/pages/SimulationRedirect";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import AuditOverlay from "@/components/AuditOverlay";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Handle OAuth callback BEFORE any routing (synchronous check).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* V4.49 — ACQUISITION : tunnel public non authentifié */}
      {/* V6.0 — /simulation → redirige vers /s/teddy (rétrocompat liens Instagram existants) */}
      <Route path="/simulation" element={<SimulationRedirect />} />
      <Route path="/s/:slug" element={<SimulationPublic />} />
      <Route path="/l/:code" element={<ShortLinkRedirect />} />
      <Route path="/mentions-legales" element={<MentionsLegales />} />
      <Route path="/confidentialite" element={<Confidentialite />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardCommando />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dossier/:id"
        element={
          <ProtectedRoute>
            <FicheDossier />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cash"
        element={
          <ProtectedRoute>
            <DashboardCash />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pilotage"
        element={
          <ProtectedRoute>
            <PilotageStrategique />
          </ProtectedRoute>
        }
      />
      <Route path="/signes" element={<ProtectedRoute><DossiersSignes /></ProtectedRoute>} />
      <Route path="/perdus" element={<ProtectedRoute><DossiersPerdus /></ProtectedRoute>} />
      <Route path="/standby" element={<ProtectedRoute><DossiersStandby /></ProtectedRoute>} />
      <Route path="/commando/recommandations" element={<ProtectedRoute><CommandoRecommandations /></ProtectedRoute>} />
      <Route path="/dossiers" element={<ProtectedRoute><Dossiers /></ProtectedRoute>} />
      <Route path="/leads" element={<ProtectedRoute><Leads /></ProtectedRoute>} />
      <Route path="/taches" element={<ProtectedRoute><Taches /></ProtectedRoute>} />
      <Route path="/apporteurs" element={<ProtectedRoute><Apporteurs /></ProtectedRoute>} />
      <Route path="/marketplace" element={<ProtectedRoute><Marketplace /></ProtectedRoute>} />
      <Route path="/commissions" element={<ProtectedRoute><Commissions /></ProtectedRoute>} />
      <Route path="/suivi-hebdo" element={<ProtectedRoute><SuiviHebdo /></ProtectedRoute>} />
      <Route path="/entreprises" element={<ProtectedRoute><Entreprises /></ProtectedRoute>} />
      <Route path="/relances/retard" element={<ProtectedRoute><RelancesRetard /></ProtectedRoute>} />
      <Route path="/dossiers/en-cours" element={<Navigate to="/dossiers?tab=montage" replace />} />
      <Route path="/dossiers/mandates" element={<Navigate to="/dossiers?tab=banque" replace />} />
      <Route path="/dossiers/signes" element={<Navigate to="/signes" replace />} />
      <Route path="/dossiers/perdus" element={<Navigate to="/perdus" replace />} />
      <Route path="/objectifs" element={<ProtectedRoute><Objectifs /></ProtectedRoute>} />
      <Route path="/import" element={<ProtectedRoute><ImportCSV /></ProtectedRoute>} />
      <Route path="/parametres/mon-simulateur" element={<ProtectedRoute><SettingsSimulator /></ProtectedRoute>} />
      <Route path="/admin/courtiers" element={<ProtectedRoute><AdminBrokers /></ProtectedRoute>} />
      <Route path="/admin/scoring-v8" element={<ProtectedRoute><AdminScoringV8 /></ProtectedRoute>} />
      <Route path="/bos" element={<ProtectedRoute><BosCockpit /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <AuditOverlay />
          <Toaster
            theme="light"
            position="top-right"
            toastOptions={{
              style: {
                background: "#FFFFFF",
                border: "1px solid var(--cf-border)",
                color: "var(--cf-text)",
                boxShadow: "0 8px 24px rgba(15, 23, 42, 0.08)",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
